namespace TabAurous.OMS {
    export namespace DesignEnquiryService {
        export const baseUrl = 'OMS/DesignEnquiry';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<DesignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/DesignEnquiry/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>DesignEnquiryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
